"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('store/tokenStore',["require", "exports"], function (require, exports) {
    "use strict";

    var TokenStore = function () {
        function TokenStore() {
            _classCallCheck(this, TokenStore);

            this.accessTokenStorageKey = 'accessTokenV7';
            this.refreshTokenStorageKey = 'refreshToken';
            this.accessTokenExpiresInStorageKey = 'acessTokenExpiresIn';
            this.isPersistent = false;
        }

        _createClass(TokenStore, [{
            key: "clearAccessToken",
            value: function clearAccessToken() {
                localStorage.removeItem(this.accessTokenStorageKey);
                sessionStorage.removeItem(this.accessTokenStorageKey);
                localStorage.removeItem(this.refreshTokenStorageKey);
                sessionStorage.removeItem(this.refreshTokenStorageKey);
                localStorage.removeItem(this.accessTokenExpiresInStorageKey);
                sessionStorage.removeItem(this.accessTokenExpiresInStorageKey);
            }
        }, {
            key: "setPersistence",
            value: function setPersistence(persistent) {
                this.isPersistent = persistent;
            }
        }, {
            key: "setAccessToken",
            value: function setAccessToken(accessToken, refreshToken, accessTokenExpiresIn) {
                var storage = this.isPersistent ? localStorage : sessionStorage;
                storage[this.accessTokenStorageKey] = accessToken;
                this.setRefreshToken(refreshToken);
                this.setAccessTokenExpiresIn(accessTokenExpiresIn);
            }
        }, {
            key: "setRefreshToken",
            value: function setRefreshToken(refreshToken) {
                var storage = this.isPersistent ? localStorage : sessionStorage;
                storage[this.refreshTokenStorageKey] = refreshToken;
            }
        }, {
            key: "setAccessTokenExpiresIn",
            value: function setAccessTokenExpiresIn(accessTokenExpiresIn) {
                var storage = this.isPersistent ? localStorage : sessionStorage;
                storage[this.accessTokenExpiresInStorageKey] = accessTokenExpiresIn;
            }
        }, {
            key: "getAccessToken",
            value: function getAccessToken() {
                var sessionAccessToken = sessionStorage[this.accessTokenStorageKey];
                if (sessionAccessToken) {
                    this.isPersistent = false;
                    return sessionAccessToken;
                }
                this.isPersistent = true;
                return localStorage[this.accessTokenStorageKey];
            }
        }, {
            key: "getRefreshToken",
            value: function getRefreshToken() {
                var sessionRefreshToken = sessionStorage[this.refreshTokenStorageKey];
                if (sessionRefreshToken) {
                    this.isPersistent = false;
                    return sessionRefreshToken;
                }
                this.isPersistent = true;
                return localStorage[this.refreshTokenStorageKey];
            }
        }, {
            key: "getAccessTokenExpiresIn",
            value: function getAccessTokenExpiresIn() {
                var sessionExpiryDate = sessionStorage[this.accessTokenExpiresInStorageKey];
                if (sessionExpiryDate) {
                    this.isPersistent = false;
                    return parseInt(sessionExpiryDate);
                }
                this.isPersistent = true;
                sessionExpiryDate = localStorage[this.accessTokenExpiresInStorageKey];
                if (sessionExpiryDate) {
                    return parseInt(sessionExpiryDate);
                }
                return null;
            }
        }]);

        return TokenStore;
    }();

    return new TokenStore();
});
//# sourceMappingURL=tokenStore.js.map;
